<template>
  <div class="alerts-container">
    <div class="d-flex justify-content-between mb-4">
      <div class="d-flex align-items-center">
        <h6 class="text-orange-dark text-uppercase mr-3 mb-0">
          <slot name="alert-type-heading"></slot>
        </h6>
        <slot name="alert-type-count"></slot>
      </div>
      <div class="toggle-button-container d-flex justify-content-end">
        <slot name="alert-type-toggle"></slot>
      </div>
    </div>
    <transition name="slide-down">
      <slot name="alert-type-info"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  //
}
</script>
